var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.5566H12M12 20.5566L18 26.5566M12 20.5566L18 14.5566",
    stroke: "#4D5761",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.05664,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#D2D6DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderBackIcon);
export default __webpack_public_path__ + "static/media/BorderBackIcon.8c8741df811e0b98077ae12a48fbe56e.svg";
export { ForwardRef as ReactComponent };